import hero1 from "../images/carousel-1.jpg";
import hero2 from "../images/carousel-2.jpg";
import overlayBottom from "../images/overlay-bottom.png";
import overlayTop from "../images/overlay-top.png";
import about from "../images/about.png";
import service1 from "../images/service-1.jpg";
import service2 from "../images/service-2.jpg";
import service3 from "../images/service-3.jpg";
import service4 from "../images/service-4.jpg";
import menu1 from "../images/menu-1.jpg";
import menu2 from "../images/menu-2.jpg";
import menu3 from "../images/menu-3.jpg";
import background from "../images/bg.jpg";
import testimonial1 from "../images/testimonial-1.jpg";
import testimonial2 from "../images/testimonial-2.jpg";
import testimonial3 from "../images/testimonial-3.jpg";
import testimonial4 from "../images/testimonial-4.jpg";

export const images = {
    hero1,
    hero2,
    overlayBottom,
    overlayTop,
    about,
    service1,
    service2,
    service3,
    service4,
    menu1,
    menu2,
    menu3,
    background,
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,
}